import React, { Fragment, useState, useEffect } from 'react'
import { useStore } from '@nanostores/react'
import { userData } from '@stores/userStore'
import { cartData } from '@stores/cartStore'
import User from '@components/Icons/User.jsx'
import UserSolid from '@components/Icons/UserSolid.jsx'
import UserCircle from '@components/Icons/UserCircle.jsx'
import Gift from '@components/Icons/Gift.jsx'
import OpenBox from '@components/Icons/OpenBox'
import Person from '@components/Icons/Person.jsx'
import { chord } from '@api/chord.js'
import useHover from '@hooks/useHover'
import { registryData } from '@stores/registryStore'
import { updateCartDiscountCodes, getCart } from '@api/shopify'

const NavAccount = ({ component }) => {
    const $userData = useStore(userData || null)
    const [haveUser, setHaveUser] = useState(false)
    const [hoverRef, isHovered] = useHover(false)
    const [hasRegistry, setHasRegistry] = useState(false)
    const [show, setShow] = useState(false)

    //

    /* prevents flash of unlogged-in user in nav */
    useEffect(() => {
        if ($userData && $userData.email) {
            setHaveUser(true)
        } else {
            setHaveUser(false)
        }
    }, [$userData])

    useEffect(() => {
        if (isHovered) {
            setShow(true)
        }

        return () => {
            setShow(false)
        }
    }, [isHovered])

    // Helper function to check if a discount code is from Inveterate
    const isInveterateDiscountCode = (code) => {
        return code && code.startsWith('REDEEM+');
    };

    // Remove Inveterate discount codes from cart
    const removeInveterateDiscounts = async () => {
        const currentCartData = cartData.get();

        if (!currentCartData?.cartId || !currentCartData?.discountCodes) {
            console.log('No cart data or discount codes to remove');
            return;
        }

        console.log('Removing Inveterate discounts on logout...');

        // Filter out Inveterate discount codes
        const nonInveterateDiscounts = currentCartData.discountCodes
            .filter(dc => dc.applicable && !isInveterateDiscountCode(dc.code))
            .map(dc => dc.code);

        const inveterateDiscounts = currentCartData.discountCodes
            .filter(dc => dc.applicable && isInveterateDiscountCode(dc.code));

        if (inveterateDiscounts.length > 0) {
            console.log('Found Inveterate discount codes to remove on logout:', inveterateDiscounts.map(dc => dc.code));

            try {
                // Update cart with only non-Inveterate discount codes
                const discountResult = await updateCartDiscountCodes(currentCartData.cartId, nonInveterateDiscounts);

                if (discountResult.body?.cartDiscountCodesUpdate?.cart) {
                    const updatedCart = discountResult.body.cartDiscountCodesUpdate.cart;

                    console.log('Successfully removed Inveterate discounts on logout');

                    // Update cart store with new data
                    const cartObj = {
                        ...currentCartData,
                        cost: updatedCart.cost,
                        lines: updatedCart.lines.edges,
                        discountCodes: updatedCart.discountCodes,
                        discountAllocations: updatedCart.discountAllocations,
                    };

                    cartData.set(cartObj);
                }
            } catch (error) {
                console.error('Failed to remove Inveterate discount codes on logout:', error);
            }
        } else {
            console.log('No Inveterate discount codes found in cart on logout');
        }
    };

    const handleLogout = async () => {
        console.log('Logout initiated - clearing user data and removing Inveterate discounts...');

        // Remove Inveterate discounts before clearing user data
        await removeInveterateDiscounts();

        // Clear user data
        userData.set({});
        registryData.set({});
        localStorage.removeItem('ma_user');
        chord.reset();

        localStorage.setItem('hasRegistry', 'false');
        document.cookie =
            'access_token=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT'
        document.cookie =
            'ma_registry_id=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT'
        localStorage.removeItem('registry_token')
        localStorage.removeItem('registryId')

        console.log('Logout completed - user data cleared and Inveterate discounts removed');

        setTimeout(() => {
            window.location.href = '/'
        }, 1000)
    }

    return (
        <div
            className={`account-wrap h-full font-akkurat ${show ? 'h-8' : ''}`}
            ref={hoverRef}
        >
            <div
                className={`nav-account-outer relative items-center justify-center h-full  ${
                    !haveUser ? '' : ''
                }`}

            >
                <div className="nav-account-inner h-full cursor-pointer">
                    {haveUser ? (
                        <a className="flex items-center justify-center gap-x-1 bg-background-secondary-subtle hover:bg-background-secondary-active rounded-full py-2 px-2" href="/account">
                            <UserSolid width="w-[20px]" />
                            {component === "PrimaryNavScroll" ? '' : <span className="text-web-b2-body-2">Profile</span>}
                        </a>
                    ) : (
                        <a className="flex items-center justify-center gap-x-1 bg-background-secondary-subtle hover:bg-background-secondary-active rounded-full py-2 px-2" href="/account/login">
                            <UserCircle width="w-[20px]" />
                            {component === "PrimaryNavScroll" ? '' : <span className="text-web-b2-body-2">Sign In</span>}
                        </a>
                    )}
                </div>



            </div>
            {/* {show ? (
                <div className="account-nav-tab absolute top-2 -right-4 w-[300px] h-14 bg-transparent">
                    &nbsp;
                </div>
            ) : null} */}

            {/* <div
                className={`account-outer absolute top-14 m-auto z-10 ${
                    show ? 'flex' : 'hidden'
                }`}
            >
                <div className="account-inner p-3 bg-beige text-flint flex-col w-[300px]">
                    <div className="flex pl-3 flex-col">

                        {!haveUser ? (
                            <div className="logged-out flex flex-col text-sm items-start justify-start">
                                <div className="create-account flex items-center justify-start my-2 hover:text-ash hover:font-bold">
                                    <div className="account-icon w-[24px]">
                                        <Person width="w-[11px]" />
                                    </div>
                                    <a
                                        className="hover:text-ash"
                                        href="/account/login"
                                        onClick={() => {
                                            // Store current page for redirect after login
                                            if (typeof window !== 'undefined') {
                                                localStorage.setItem('auth_redirect_url', window.location.href);
                                            }
                                        }}
                                    >
                                        Create Account
                                    </a>
                                </div>
                                <div className="start-a-registry flex items-center justify-start my-2 hover:text-ash hover:font-bold">
									<div className="account-icon w-[24px] -left-[4px] relative">
										<OpenBox width="w-[21px]" />
									</div>
									<a
										href="/pages/registry"
										className="nav-utility-registry hover:text-ash"
									>
										{hasRegistry ? "Your Registry" : "Start a Registry"}
									</a>
								</div>
                                <span className="pipe mx-2">
                                    <span className="mx-2">|</span>
                                </span>
                                <div className="log-in flex items-center justify-start my-2 hover:text-ash hover:font-bold">
                                    <div className="account-icon w-[24px] relative left-[-1px]">
                                        <User width="w-[16px]" />
                                    </div>
                                    <a
                                        className=""
                                        href="/account/login"
                                        onClick={() => {
                                            // Store current page for redirect after login
                                            if (typeof window !== 'undefined') {
                                                localStorage.setItem('auth_redirect_url', window.location.href);
                                            }
                                        }}
                                    >
                                        Sign In To Get Rewards
                                    </a>
                                </div>
                            </div>
                        ) : null}
                        {haveUser ? (
                            <div className="logged-in flex flex-col text-sm items-start justify-start">
                                <div className="user-account flex items-center justify-start my-2 hover:text-ash hover:font-bold">
                                    <a
                                        className="flex items-center justify-start hover:text-ash"
                                        href="/account"
                                    >
                                        <div className="account-icon w-[24px] ">
                                            <Person width="w-[11px]" />
                                        </div>
                                        Hi,{' '}
                                        {$userData && $userData.firstName
                                            ? $userData.firstName + '!'
                                            : ''}
                                    </a>
                                </div>
                                <div className="start-a-registry flex items-center justify-start my-2 hover:text-ash hover:font-bold">
									<div className="account-icon w-[24px] -left-[4px] relative">
										<OpenBox width="w-[21px]" />
									</div>
									<a
										href="/pages/registry"
										className="nav-utility-registry hover:text-ash"
									>
										{hasRegistry ? "Your Registry" : "Start a Registry"}
									</a>
								</div>

                                <div className="log-in flex items-center justify-start my-2 hover:text-ash hover:font-bold">
                                    <div className="account-icon w-[24px] relative left-[-1px]">
                                        <User width="w-[16px]" />
                                    </div>
                                    <a className="" href="/account">
                                        Your Account
                                    </a>
                                </div>
                                <div className="log-out flex items-center justify-start my-2 hover:text-ash hover:font-bold">
                                    <span className="" onClick={handleLogout}>
                                        Log Out
                                    </span>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div> */}
        </div>
    )
}

export default NavAccount

{
    /*}{% if customer.metafields.baby_registry.registry_availability == "True" %}
                            <a href="/pages/registry" className="nav-utility-registry">Your Registry</a>
                        {% else %}
                            <a href="/pages/m-a-registry" className="nav-utility-registry">Start a Registry</a>
                        {% endif %}
                        */
}
